import Immutable from 'immutable';
import * as actionTypes from './actionTypes';
import { SET_ACTIVE_PAGE } from './../common/Pagination/actionTypes';

const INITIAL_STATE = Immutable.fromJS({
    form: {
        formValues: {
            id: '',
            name: '',
            email: '',
            username: '',
            password: '',
            is_active: 1,
            type: '',
            phone: '',
            user_type_1: '',
            user_type_2: '',
            user_type_3: '',
            user_discount_id: '',
            department_id: '',
        },
        formErrors: {},
        isSaving: false
    },
    activeElement: {
        data: null,
        selectedProductWindows: [],
        isFetching: false
    },
    delete: {
        id: null,
        isDeleting: false
    },
    elements: {
        data: [],
        processedElements: [],
        isFetching: false
    },
    pagination: {
        totalPages: 0,
        selectedPage: 1,
        elementsPerPage: 20
    },
    sort: {
        column: 'name',
        type: 'asc'
    },
    filter: {
        fields: []
    },
    information: {
        productWindows: [],
        departments: [],
        isFetching: false
    },
    permissions: [
        {
            name: 'Dashboard', label: 'Dashboard', subnames: [
                { name: 'View', selected: 0 }
            ]
        },
        {
            name: 'Quotes', label: 'Quotes', subnames: [
                { name: 'View All', selected: 0 },
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Orders', label: 'Orders', subnames: [
                { name: 'View All', selected: 0 },
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Production', label: 'Production', subnames: [
                { name: 'View All', selected: 0 },
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Shipping', label: 'Shipping', subnames: [
                { name: 'View All', selected: 0 },
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Customers', label: 'Customers', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Vendors', label: 'Vendors', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Products', label: 'Products', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Product Categories', label: 'Product Categories', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Product Dashboards', label: 'Products Dashboards', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Change Order', label: 'Change Order', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Create', selected: 0 },
                { name: 'Enter Costs', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Deposits', label: 'Deposits', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Landry\'s', label: 'Landry\'s', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Shipping/Receiving', label: 'S/R', subnames: [
                { name: 'Warehouse', selected: 0 },
                { name: 'Sales/CSR', selected: 0 }
            ]
        },
        {
            name: 'Users', label: 'Users', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Customer Discounts', label: 'Discounts', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Indutries', label: 'Industries', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Departments', label: 'Departments', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Turnaround', label: 'Turnaround', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Presses', label: 'Presses', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Inks', label: 'Inks', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Digital', label: 'Digital', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Cutting', label: 'Cutting', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Die-Cutting', label: 'Die-Cut', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Drilling', label: 'Drilling', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Scoring', label: 'Scoring', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Padding', label: 'Padding', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Paper Categories', label: 'Categories', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Paper Vendors', label: 'Vendors', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Papers', label: 'Papers', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Folding Machines', label: 'Machines', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Folding Types', label: 'Types', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Saddle Stitching Machines', label: 'Saddle Stitching', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Perfect Binding Machines', label: 'Perfect Binding', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Coil Binding Machines', label: 'Coil Binding', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Corner Staple Machines', label: 'Corner Staple', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Side Staple Machines', label: 'Side Staple', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Spiral Binding Machines', label: 'Spiral Binding', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Banding Types', label: 'Types', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Banding Machines', label: 'Machines', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Wrapping Types', label: 'Types', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Wrapping Machines', label: 'Machines', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Shrink Wrapping Machines', label: 'Machines', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Shrink Wrapping Types', label: 'Types', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Shrink Wrapping Categories', label: 'Categories', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Packages', label: 'Packages', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Mailing Operations', label: 'Mailing', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Flat Hand Gathering', label: 'Flat', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Multi-Page Hand Gathering', label: 'Multi-Page', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Counting', label: 'Counting', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Large Format Machines', label: 'Machines', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Substrates', label: 'Substrates', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Laminates', label: 'Laminates', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Accessories', label: 'Accessories', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Data Processing', label: 'Data Processing', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Inkjet', label: 'Inkjet', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Inserting', label: 'Inserting', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Perfect Match', label: 'Perfect Match', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Wafer Seal', label: 'Wafer Seal', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Affix Labels', label: 'Affix Labels', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Certified Mail', label: 'Certified Mail', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Art', label: 'Art', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Handwork', label: 'Handwork', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Pressure Seal Forms', label: 'Pressure Seal', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Index Tabs', label: 'Index Tabs', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Labels', label: 'Labels', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'NCR Forms', label: 'NCR Forms', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Timeline Log', label: 'Timeline Log', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Products Catalog', label: 'Products Catalog', subnames: [
                { name: 'View', selected: 0 }
            ]
        },
        {
            name: 'Employees', label: 'Employees', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Envelope Presses', label: 'Presses', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Envelope Papers', label: 'Papers', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'Envelope Types', label: 'Types', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'PQT', label: 'PQT', subnames: [
                { name: 'Super Dashboard', selected: 0 },
                { name: 'Super Manager', selected: 0 },
                { name: 'VP', selected: 0 },
                { name: 'Department Manager', selected: 0 },
                { name: 'CSR', selected: 0 },
                { name: 'Sales', selected: 0 },
                { name: 'Worker', selected: 0 },
                { name: 'Accounting', selected: 0 },
            ]
        },
        {
            name: 'AC Sales Report', label: 'AC Sales Report', subnames: [
                { name: 'Export', selected: 0 },
            ]
        },
        // {
        //     name: 'UTHealth', label: 'UTHealth', subnames: [
        //         { name: 'Orders', selected: 0 },
        //     ]
        // },
        {
            name: 'DPT Data Processing', label: 'DPT Data Processing', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Digital', label: 'DPT Digital', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Press', label: 'DPT Press', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Bindery', label: 'DPT Bindery', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Inkjet', label: 'DPT Inkjet', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Inkjet Material', label: 'DPT Inkjet Material', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Inserting', label: 'DPT Inserting', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Outside Service', label: 'DPT Outside Service', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Hand', label: 'DPT Hand', subnames: [
                { name: 'View', selected: 0 },
                { name: 'Edit', selected: 0 },
                { name: 'Delete', selected: 0 }
            ]
        },
        {
            name: 'DPT Calculator', label: 'DPT Calculator', subnames: [
                { name: 'View', selected: 0 },
            ]
        },
        // {
        //     name: 'Invoices', label: 'Invoices', subnames: [
        //         { name: 'View', selected: 0 },
        //         { name: 'Edit', selected: 0 },
        //         { name: 'Delete', selected: 0 }
        //     ]
        // },
    ]
});

export default function (state = INITIAL_STATE, action) {
    state = Immutable.fromJS(state);

    if (window.location['pathname'] !== '/users') {
        state = INITIAL_STATE;
        return state.toJS();
    }

    switch (action.type) {
        case actionTypes.FETCH_ELEMENTS:
            state = state.setIn(['elements', 'isFetching'], true)
                .setIn(['elements', 'data'], [])
                .setIn(['elements', 'processedElements'], [])
                .setIn(['pagination', 'totalPages'], 0)
                .setIn(['pagination', 'selectedPage'], 1);
            break;

        case actionTypes.FETCH_ELEMENTS_SUCCESS:
            state = state.setIn(['elements', 'isFetching'], false)
                .setIn(['elements', 'data'], action.payload)
                .setIn(['pagination', 'totalPages'], Math.ceil(action.payload.length / 20))
                .setIn(['pagination', 'selectedPage'], 1);
            break;

        case actionTypes.FETCH_ELEMENTS_FAILURE:
            state = state.setIn(['elements', 'isFetching'], false);
            break;

        case actionTypes.UPDATE_FORM_VALUE:
            state = state.setIn(['form', 'formValues', action.payload.name], action.payload.value);
            break;

        case SET_ACTIVE_PAGE:
            state = state.setIn(['pagination', 'selectedPage'], action.payload);
            break;

        case actionTypes.SET_SORT:
            state = state.setIn(['sort', 'column'], action.payload.column)
                .setIn(['sort', 'type'], action.payload.type);
            break;

        case actionTypes.SET_ELEMENTS:
            state = state.setIn(['elements', 'data'], action.payload);
            break;

        case actionTypes.CHANGE_ATTRIBUTE:
            state = state.setIn(['elements', 'data'], action.payload);
            break;

        case actionTypes.SAVE:
            state = state.setIn(['form', 'isSaving'], true);
            break;

        case actionTypes.SAVE_SUCCESS:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_FAILURE:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_ELEMENT:
            state = state.setIn(['form', 'isSaving'], true);
            break;

        case actionTypes.SAVE_ELEMENT_SUCCESS:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.SAVE_ELEMENT_FAILURE:
            state = state.setIn(['form', 'isSaving'], false);
            break;

        case actionTypes.DELETE_ELEMENT:
            state = state.setIn(['delete', 'isDeleting'], true);
            break;

        case actionTypes.DELETE_ELEMENT_SUCCESS:
            state = state.setIn(['delete', 'isDeleting'], false);
            break;

        case actionTypes.DELETE_ELEMENT_FAILURE:
            state = state.setIn(['delete', 'isDeleting'], false);
            break;

        case actionTypes.SET_ID_FOR_DELETE:
            state = state.setIn(['delete', 'id'], action.payload);
            break;

        case actionTypes.RESET_FORM:
            state = state.setIn(['form', 'formValues'], {
                id: '',
                name: '',
                email: '',
                username: '',
                password: '',
                is_active: 1,
                type: '',
                phone: '',
                user_type_1: '',
                user_type_2: '',
                user_type_3: '',
                user_discount_id: '',
                department_id: '',
            }).setIn(['form', 'formErrors'], {});
            break;

        case actionTypes.SET_FORM_ERRORS:
            state = state.setIn(['form', 'formErrors'], action.payload.errors)
                .setIn(['form', 'formErrorMessages'], action.payload.errorMessages);
            break;

        case actionTypes.SET_FORM_ERROR:
            state = state.setIn(['form', 'formErrors', action.payload.name], action.payload.value)
                .setIn(['form', 'formErrorMessages', action.payload.name], action.payload.errorMessage);
            break;

        case actionTypes.SET_ACTIVE_ELEMENT:
            state = state.setIn(['form', 'formErrors'], {})
                .setIn(['activeElement', 'data'], action.payload)
                .updateIn(['activeElement', 'selectedProductWindows'], (selectedProductWindows) => {
                    let ids = action.payload.product_windows.map((productWindow) => productWindow['id']);
                    return Immutable.List(ids);
                })
                .setIn(['form', 'formValues', 'id'], action.payload.id)
                .setIn(['form', 'formValues', 'name'], action.payload.name)
                .setIn(['form', 'formValues', 'email'], action.payload.email)
                .setIn(['form', 'formValues', 'username'], action.payload.username)
                .setIn(['form', 'formValues', 'password'], '')
                .setIn(['form', 'formValues', 'is_active'], action.payload.is_active)
                .setIn(['form', 'formValues', 'type'], action.payload.type)
                .setIn(['form', 'formValues', 'phone'], action.payload.phone)
                .setIn(['form', 'formValues', 'user_type'], action.payload.user_type == null ? '' : action.payload.user_type)
                .setIn(['form', 'formValues', 'user_type_1'], action.payload.user_type_1 == null ? '' : action.payload.user_type_1)
                .setIn(['form', 'formValues', 'user_type_2'], action.payload.user_type_2 == null ? '' : action.payload.user_type_2)
                .setIn(['form', 'formValues', 'user_type_3'], action.payload.user_type_3 == null ? '' : action.payload.user_type_3)
                .setIn(['form', 'formValues', 'user_discount_id'], action.payload.user_discount_id == null ? '' : action.payload.user_discount_id)
                .setIn(['form', 'formValues', 'department_id'], action.payload.department_id == null ? '' : action.payload.department_id);
            break;

        case actionTypes.RESET_STATE:
            state = INITIAL_STATE;
            break;

        case actionTypes.CHANGE_FILTER:
            state = state.setIn(['pagination', 'selectedPage'], 1)
                .updateIn(['filter', 'fields'], (fields) => {
                    const index = fields.findIndex(field => field.get('name') === action.payload.name);
                    if (action.payload.value === '') {
                        return fields.delete(index);
                    } else {
                        if (index === -1) {
                            return fields.push({ name: action.payload.name, value: action.payload.value });
                        } else {
                            return fields.set(index, { name: action.payload.name, value: action.payload.value });
                        }
                    }
                });
            break;

        case actionTypes.PROCESS_ELEMENTS:
            state = state.setIn(['elements', 'processedElements'], action.payload)
                .setIn(['pagination', 'totalPages'], Math.ceil(action.payload.length / 20));
            break;

        case actionTypes.CHECK_PERMISSION:
            state = state.updateIn(['permissions'], (permissions) => {
                let index1 = permissions.findIndex(permission => permission.get('name') === action.payload.name);
                let permission = permissions.get(index1);
                let index2 = permission.get('subnames').findIndex(element => element.get('name') === action.payload.subname);
                return permissions.setIn([index1, 'subnames', index2, 'selected'], action.payload.value);
            });
            break;

        case actionTypes.CHECK_MAIN_PERMISSION:
            state = state.updateIn(['permissions'], (permissions) => {
                let index1 = permissions.findIndex(permission => permission.get('name') === action.payload.name);
                let subnames = permissions.get(index1).get('subnames').toJS();

                for (let i = 0; i < subnames.length; i++) {
                    subnames[i]['selected'] = action.payload.value;
                }

                return permissions.setIn([index1, 'subnames'], subnames);
            });
            break;

        case actionTypes.CHECK_ALL_PERMISSIONS:
            state = state.updateIn(['permissions'], (permissions) => {
                let permissionsArray = permissions.toJS();
                for (let i = 0; i < permissionsArray.length; i++) {
                    if (permissionsArray[i]['name'] !== 'PQT') {
                        for (let j = 0; j < permissionsArray[i]['subnames'].length; j++) {
                            permissionsArray[i]['subnames'][j]['selected'] = action.payload.value;
                        }
                    }
                }
                return permissionsArray;
            });
            break;

        case actionTypes.SETUP_PERMISSIONS:
            state = state.setIn(['permissions'], action.payload);
            break;

        case actionTypes.FETCH_ELEMENT:
            state = state.setIn(['activeElement', 'isFetching'], true);
            break;

        case actionTypes.FETCH_ELEMENT_SUCCESS:
            state = state.setIn(['activeElement', 'isFetching'], false);
            break;

        case actionTypes.FETCH_ELEMENT_FAILURE:
            state = state.setIn(['activeElement', 'isFetching'], false);
            break;

        case actionTypes.FETCH_INFORMATION:
            state = state.setIn(['information', 'isFetching'], true)
                .setIn(['information', 'productWindows'], [])
                .setIn(['information', 'departments'], []);
            break;

        case actionTypes.FETCH_INFORMATION_SUCCESS:
            state = state.setIn(['information', 'isFetching'], false)
                .setIn(['information', 'productWindows'], action.payload.productWindows)
                .setIn(['information', 'departments'], action.payload.departments);
            break;

        case actionTypes.FETCH_INFORMATION_FAILURE:
            state = state.setIn(['information', 'isFetching'], false);
            break;

        case actionTypes.TOGGLE_PRODUCT_WINDOW:
            state = state.updateIn(['activeElement', 'selectedProductWindows'], (selectedProductWindows) => {
                const element = selectedProductWindows.find((productWindow) => parseInt(productWindow) === parseInt(action.payload));
                if (element === undefined) {
                    return selectedProductWindows.push(action.payload);
                } else {
                    const index = selectedProductWindows.indexOf(element);
                    return selectedProductWindows.delete(index);
                }
            });
            break;

        default:
            break;
    }

    return state.toJS();
}
